import classNames from 'classnames'
import { isEmpty } from 'lodash'

import css from './product-about.scss'
import { Row, Col } from 'react-bootstrap'
import { SubHeading } from '../../../components/headings'

const ProductAbout = ({ about, whatWeLove }) => {
  let showWhatWeLove = !isEmpty(whatWeLove)
  let showAbout = !isEmpty(about)
  return (
    <Row className="mbxl">
      {showWhatWeLove ? (
        <Col
          sm={showAbout ? 5 : 10}
          smPush={showAbout ? 6 : 0}
          smOffset={showAbout ? 0 : 1}
          md={showAbout ? 5 : 10}
          mdPush={showAbout ? 7 : 0}
          mdOffset={showAbout ? 0 : 1}
          className="text-center"
        >
          <div className="phxl-md pvl-md">
            <SubHeading className="h6 text-uppercase">
              What we
              <i
                aria-label="love"
                className={classNames(
                  'fa fa-heart icon-filled-primary',
                  css.heart
                )}
              />
              about it
            </SubHeading>
            <div className={classNames({ [css.whatWeLoveLarge]: !showAbout })}>
              {whatWeLove}
            </div>
          </div>
        </Col>
      ) : null}
      {showWhatWeLove && showAbout ? (
        <div className="visible-xs container mvxl">
          <hr />
        </div>
      ) : null}
      {showAbout ? (
        <Col
          sm={5}
          smPull={showWhatWeLove ? 5 : 0}
          smOffset={1}
          md={6}
          mdPull={showWhatWeLove ? 5 : 0}
          className={classNames({ brs: showWhatWeLove })}
        >
          <SubHeading className="h5 text-bold mbs">
            About this Product
          </SubHeading>
          <div
            className={css.about}
            dangerouslySetInnerHTML={{ __html: about }}
          />
        </Col>
      ) : null}
    </Row>
  )
}

export default ProductAbout
